import React from 'react'
import Box from './Box'
import axios from 'axios'

const minReportLength = 10

const ReportToAdmin = ({
    generateHeaderCloseIco,
    socket,
    modalTitle,
    me,
    isEditing = false,
    currSingeNews,
    reportSubject,
    reporter
}) => {

    const [infoMessage, setInfoMessage] = React.useState('')
    const [reportComment, setReportComment] = React.useState('')
    const [inputBorderColor, setInputBorderColor] = React.useState('white')


    const handleReportChange = (e) => {
        setReportComment(e.target.value)
        setInputBorderColor(e.target.value.length <= minReportLength ? 'white' : 'mediumAquaMarine')
    }

    const handleReporting = () => {
        socket.emit('reportToAdmin', {
            currSingeNews,
            reportSubject,
            reporter,
            reportComment
        })

        setInfoMessage('Uspješno si prijavio/la neprikladan sadržaj. Možete zatvoriti prozor.')
    }

    const generateReportForm = () => {
        return (
            <div className="column p-right-20">
                {infoMessage.length !== 0 && <p className="form-p mediumaquamarine margin-top">{infoMessage}</p>}
                {infoMessage.length === 0 && <div className="margin-bottom w100 margin-top">
                    <p className="form-p margin-bottom">{`Dragi/a ${reporter}, pomozi mi u održavanju uredne i sigurne zajednice tako što ćeš prijaviti neprikladan sadržaj. Molimo te da ukratko navedeš razlog prijave. Nastojat ću reagirat u roku 24 sata.`}</p>
                    <p className="margin-bottom">{`Prijavljujete - ${reportSubject}`}</p>

                    <div className="form-item margin-bottom">
                        <input
                            type="text"
                            style={{ borderColor: inputBorderColor }}
                            value={reportComment}
                            minLength={minReportLength}
                            onChange={handleReportChange}
                            className="mm-input w100"
                            id="Repoprt"
                            name="Report"
                            placeholder='Razlog za prijavu'
                        />
                    </div>
                    {reportComment.length !== 0 && <p className="form-p"><span><em>Razlog za prijavu</em></span></p>}

                    <button onClick={handleReporting} disabled={reportComment.length <= minReportLength} className="content-button w30 margin-top">
                        Prijavi adminu
                    </button>
                </div>}
            </div>
        )
    }

    return (
        <div className="pop-up">
            <div className="pop-up-content">
                <div className="pop-up__title margin-bottom">
                    <div className="pop-up__title__content">
                        {modalTitle}
                        {generateHeaderCloseIco()}
                    </div>
                </div>
                <div className="modal-content-wrapper">
                    {generateReportForm()}
                </div>

            </div>
        </div>
    )
}

export default ReportToAdmin